import { render } from "./StoryCommentEmojiButton.vue.js?vue&type=template&id=60f67900!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentEmojiButton.vue?vue&type=template&id=60f67900"
import script from "./StoryCommentEmojiButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentEmojiButton.vue?vue&type=script&lang=js"
export * from "./StoryCommentEmojiButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentEmojiButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentEmojiButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60f67900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60f67900', __exports__)) {
    api.reload('60f67900', __exports__)
  }
  
  module.hot.accept("./StoryCommentEmojiButton.vue.js?vue&type=template&id=60f67900!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentEmojiButton.vue?vue&type=template&id=60f67900", () => {
    api.rerender('60f67900', render)
  })

}


export default __exports__